export const urls = {
  confirmEmail: '/v1/users/confirm-email',
  requestEmailConfirmation: (userId: number) => `/v1/users/${userId}/confirm-email`,
};
